import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../css/main.scss";

function Main() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="main">
      <Header />

      <main>
        <div className="main_box1">
          <Link op to="/shop">
            <img alt="" src="/main/main1.webp" />
          </Link>
        </div>

        {/* 2 */}
        <div className="main_box2">
          <div className="enrichment-intro">
            <h2>
              Enrichment helps dogs feel better, stay fitter,
              <br />
              and behave better.
            </h2>
            <div className="icon-row">
              <div className="icon-item">
                <div className="icon-circle">
                  <img src="/main/main2-1.svg" alt="Happier mind" />
                </div>
                <span>Happier mind</span>
              </div>
              <div className="icon-item">
                <div className="icon-circle">
                  <img src="/main/main2-2.svg" alt="More Energy" />
                </div>
                <span>More Energy</span>
              </div>
              <div className="icon-item">
                <div className="icon-circle">
                  <img src="/main/main2-3.svg" alt="Good manners" />
                </div>
                <span>Good manners</span>
              </div>
            </div>

            <h3>Discover Our Enrichment Products</h3>
          </div>

          <div className="enrichment-banners">
            <div className="banner-card cognitive">
              <div className="banner-content">
                <h2>
                  Cognitive Enrichment <span className="new-badge">New</span>
                </h2>
                <p className="subtitle">
                  The modular puzzle you and your pup play as a team!
                </p>
                <ul>
                  <li>Fresh puzzles every time</li>
                  <li>Four difficulty levels in one</li>
                  <li>Fully detachable, dishwasher-safe</li>
                </ul>
                <Link
                  op
                  to="/shop"
                  onClick={toTop}
                  className="btn btn-white-blue"
                >
                  SnapTrack collection &gt;
                </Link>
              </div>
              <div className="banner-image">
                <img src="/main/main3-1.webp" alt="Cognitive Enrichment" />
              </div>
            </div>

            <div className="banner-card sensory">
              <div className="banner-content">
                <h2>Sensory Enrichment</h2>
                <p className="subtitle">
                  Multi-sensory toys that beat boredom and build focus
                </p>
                <ul>
                  <li>Stimulates sight, smell, taste and touch</li>
                  <li>Lick, chew and play</li>
                  <li>Textured geometric design</li>
                </ul>
                <Link
                  op
                  to="/shop"
                  onClick={toTop}
                  className="btn btn-yellow-black"
                >
                  TOY collection &gt;
                </Link>
              </div>
              <div className="banner-image">
                <img src="/main/main3-2.webp" alt="Sensory Enrichment" />
              </div>
            </div>

            <div className="banner-card mental">
              <div className="banner-content">
                <h2>Mental Enrichment</h2>
                <p className="subtitle">
                  Modular interactive feeder that keeps minds engaged
                </p>
                <ul>
                  <li>Adjustable challenge levels</li>
                  <li>Food-safe and BPA-Free</li>
                  <li>Dishwasher-safe</li>
                </ul>
                <Link
                  op
                  to="/shop"
                  onClick={toTop}
                  className="btn btn-white-orange"
                >
                  SPIN collection &gt;
                </Link>
              </div>
              <div className="banner-image">
                <img src="/main/main3-3.webp" alt="Mental Enrichment" />
              </div>
            </div>

            <div className="banner-card food">
              <div className="banner-content">
                <h2>Food Enrichment</h2>
                <p className="subtitle">
                  Lick mats and plates that extend mealtime and soothe stress
                </p>
                <ul>
                  <li>Textured surface for longer licking</li>
                  <li>Secure, anti-slip grip</li>
                  <li>Dishwasher-safe (Top rack)</li>
                </ul>
                <Link
                  op
                  to="/shop"
                  onClick={toTop}
                  className="btn btn-white-black"
                >
                  PAW collection &gt;
                </Link>
              </div>
              <div className="banner-image">
                <img src="/main/main3-4.webp" alt="Food Enrichment" />
              </div>
            </div>
          </div>
        </div>

        {/* 4 */}
        <div className="main_box4">
          <h3>Loved by Pets, Trusted by Owners</h3>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="card-image">
                <img src="/main/main4-1.jpg" alt="Blue the GSD with toy" />
              </div>
              <div className="card-content">
                <p>
                  "Blue is loving her Geometrics toy. They're super durable and
                  can be filled with treats (including spreadable) and bounces
                  in all directions, making it a great interactive toy."
                </p>
                <span className="feedback-source">
                  Feedback from Blue @_blue_the_gsd
                </span>
              </div>
            </div>

            <div className="testimonial-card">
              <div className="card-image">
                <img
                  src="/main/main4-2.jpg"
                  alt="Cats and dog with slow feeder"
                />
              </div>
              <div className="card-content">
                <p>"5/5 whiskers! Suitable for cats and dogs."</p>
                <span className="feedback-source">
                  Feedback from retailer Mind Body &amp; Bowl
                </span>
              </div>
            </div>

            <div className="testimonial-card">
              <div className="card-image">
                <img src="/main/main4-3.jpg" alt="Milo with paw bowl" />
              </div>
              <div className="card-content">
                <p>
                  "I like my new Pawluna slow feeder bowl! But don't think you
                  can fool me Mum... I see those fruits and veggies on there."
                </p>
                <span className="feedback-source">
                  Feedback from Milo @the.circle.of.rice
                </span>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Main;
